var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSort28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.5A1.5 1.5 0 0 1 9.5 5v14.379l2.44-2.44a1.5 1.5 0 0 1 2.12 2.122l-5 5a1.5 1.5 0 0 1-2.12 0l-5-5a1.5 1.5 0 0 1 2.12-2.122l2.44 2.44V5A1.5 1.5 0 0 1 8 3.5Zm10.94.44a1.5 1.5 0 0 1 2.12 0l5 5a1.5 1.5 0 0 1-2.12 2.12L21.5 8.622V23a1.5 1.5 0 0 1-3 0V8.621l-2.44 2.44a1.5 1.5 0 0 1-2.12-2.122l5-5Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort28);
export default __webpack_public_path__ + "static/media/sort_28.a092149b.svg";
export { ForwardRef as ReactComponent };